import { userHasPermission, userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user, claim }) => {
    // check if user kunde_id matches claim kunde_id
    if (
      userHasRole(
        user,
        ["sysadmin", "accredo", "accredo_buchungsexport"] &&
          user.kunde_id &&
          claim.kunde_id &&
          user.kunde_id === claim.kunde_id
      )
    ) {
      return true;
    }

    return false;
  },
  edit: (attachment) => {
    // optimistically allow for now, since all viewers may edit
    return true;
  },
  toggleVisibility: (user, attachment) => {
    return userHasPermission(user, "claim-attachment.all.write");
  },
};
